import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL, get } from "../api";
import type { CaseTicket } from "./useCaseTickets";

export type CaseTicketMessage = {
  id: string;
  authorType: "USER" | "ADMIN" | "SYSTEM";
  authorId?: string;
  visibility: "PUBLIC" | "INTERNAL";
  message: string;
  createdAt: string;
};

export type CaseDisputeMini = {
  id: string;
  disputeNumber: string;
  status: string;
  reasonCode?: string | null;
  createdAt: string;
};

export type CaseTicketDetail = CaseTicket & {
  messages: CaseTicketMessage[];
  disputes: CaseDisputeMini[];
};

type TicketDetailResponse = APIResponse<CaseTicketDetail>;

function useCaseTicket(
  ticketId?: string,
  options?: QueryObserverOptions<TicketDetailResponse, APIError>
) {
  const query = useQuery<TicketDetailResponse, APIError>({
    queryKey: ["userCaseTicket", ticketId],
    queryFn: () =>
      get(API_URL + `/case-management/tickets/${ticketId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    enabled: !!ticketId,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    ...options,
  });

  return {
    ticket: query.data?.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}

export default useCaseTicket;
